import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button, Col, Result, Row } from 'antd';
const UpgradeCompleteStep = () => {
    return (_jsx(Row, { children: _jsx(Col, { xs: { span: 24, offset: 0 }, md: { span: 12, offset: 6 }, children: _jsx(Result, { status: "success", title: "Registration Completed Successfully", subTitle: "You can now start accepting jobs from the marketplace", extra: [
                    _jsx(Button, { type: "primary", href: "#/app/marketplace/available", title: "View available jobs on marketplace", children: "View available jobs on marketplace" }, "available")
                ] }) }) }));
};
export default UpgradeCompleteStep;
